import { useCallback, useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

export default function usePreviousLocationPath() {
  const { key, pathname } = useLocation();
  const navigationType = useNavigationType();
  const previousPaths = useRef(new Map<string, string | undefined>());
  const current = useRef({ key, pathname });

  useEffect(() => {
    if (navigationType === 'PUSH') {
      previousPaths.current.set(key, current.current.pathname);
    }
    if (navigationType === 'REPLACE') {
      previousPaths.current.set(
        key,
        previousPaths.current.get(current.current.key),
      );
    }
    current.current = { key, pathname };
  }, [key, pathname, navigationType]);

  return useCallback(() => previousPaths.current.get(current.current.key), []);
}
